"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  question: "How does your corporate strategy drive long-term value?",
  answer: "Our approach integrates deep market analysis with agile execution. We focus on sustainable growth through operational efficiency and innovative resource management tailored to your enterprise's specific landscape."
}, {
  question: "What protocols are in place for data confidentiality?",
  answer: "We adhere to the most stringent international data protection standards. Every engagement is protected by comprehensive non-disclosure agreements and multi-layered encryption protocols for all shared assets."
}, {
  question: "Can your framework be integrated with existing systems?",
  answer: "Yes, our solutions are designed for seamless integration. We utilize modular architectures that interface effectively with legacy systems while providing the scalability needed for future expansion."
}, {
  question: "What is the typical engagement lifecycle?",
  answer: "Engagement begins with a rigorous discovery phase, followed by strategic design and phased implementation. We provide continuous monitoring and optimization to ensure objectives are met consistently."
}, {
  question: "How do you handle complex cross-border requirements?",
  answer: "Our global reach allows us to navigate diverse regulatory environments with ease. We employ regional experts who ensure compliance and cultural alignment across all international operations."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19198" id="frequently-asked-questions" ref={ref} className={`py-24 bg-background text-foreground relative overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-20 w-72 h-72 bg-primary/5 rounded-full blur-[100px]" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-primary/5 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
            Frequently Asked <span className="text-primary">Questions</span>
          </h2>
          <p className="text-lg font-sans text-muted-foreground">
            Explore our comprehensive guide to operational standards and professional engagement protocols.
          </p>
        </div>

        <div className="max-w-[50rem] mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="group border border-border rounded-lg bg-card/50 backdrop-blur-md px-6 transition-all duration-300 data-[state=open]:border-primary/50 data-[state=open]:shadow-lg hover:bg-card">
                <AccordionTrigger className="text-lg font-medium font-default text-foreground hover:no-underline py-6 [&_svg]:text-primary [&_svg]:stroke-[2] [&_svg]:size-5 [&_svg]:transition-transform [&_svg]:duration-300">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-sans text-base leading-relaxed pb-6">
                  <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 ease-out">
                    {item.answer}
                  </div>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}